import React, { useState, useEffect } from 'react';
import $ from 'jquery';

// Sample gallery data using images from the school archive
const galleryImages = [
  {
    id: 1,
    title: 'Modern Classrooms Environment',
    category: 'facilities',
    src: '/gallery/ClassRooms.jpg',
    alt: 'Best Classroom environment at Shree Umiya Patidar School'
  },
  {
    id: 2,
    title: 'Computer Lab Session',
    category: 'facilities',
    src: '/gallery/ComputerLab.jpg',
    alt: 'Students learning in Computer Lab at Tillore Khurd'
  },
  {
    id: 3,
    title: 'Cultural Dance Performance',
    category: 'cultural',
    src: '/gallery/cultural1.JPG',
    alt: 'Students performing traditional dance on stage'
  },
  {
    id: 4,
    title: 'Annual Day Gathering & Prayer',
    category: 'cultural',
    src: '/gallery/cultural3.JPG',
    alt: 'Grand gathering during evening cultural program'
  },
  {
    id: 5,
    title: 'Royal Procession / Drama',
    category: 'cultural',
    src: '/gallery/cultural5.JPG',
    alt: 'Stage performance with chariot theme'
  },
  {
    id: 6,
    title: 'Mythological Drama Play',
    category: 'cultural',
    src: '/gallery/cultural6.JPG',
    alt: 'Students in costumes enacting character on stage'
  },
  {
    id: 7,
    title: 'Garba & Traditional Celebrations',
    category: 'cultural',
    src: '/gallery/cultural7.JPG',
    alt: 'Garba and folk dance celebration'
  },
  {
    id: 8,
    title: 'Drama Presentation',
    category: 'cultural',
    src: '/gallery/cultural8.JPG',
    alt: 'Stage performance by young students'
  },
  {
    id: 9,
    title: 'Yoga for Fitness',
    category: 'sports',
    src: '/gallery/YogaFitness.jpg',
    alt: 'Mass yoga session performed by school students'
  }
];

function Gallery() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  // Filtered images
  const filteredImages = activeFilter === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === activeFilter);

  // jQuery effect for smooth fade transitions when changing filters or clicking images
  useEffect(() => {
    // Light-weight jQuery animation on image grid load/filter change
    $('.gallery-grid-item').hide().fadeIn(400);
  }, [activeFilter]);

  const openLightbox = (img) => {
    setSelectedImage(img);
    $('#lightbox-overlay').fadeIn(250);
  };

  const closeLightbox = () => {
    $('#lightbox-overlay').fadeOut(200, () => {
      setSelectedImage(null);
    });
  };

  return (
    <main className="gallery-page" id="gallery">
      {/* Hero Banner */}
      <section className="gallery-hero" aria-labelledby="gallery-title">
        <div className="gallery-hero-inner">
          <div className="gallery-hero-copy">
            <p className="gallery-eyebrow">School Memories & Events</p>
            <h1 id="gallery-title">Photo <span>Gallery</span></h1>
            <p className="gallery-lead">
              Explore vibrant moments from our campus life, modern facilities, cultural festivities, and fitness activities.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <div className="gallery-content">
        <div className="gallery-container">

          {/* Filter Navigation */}
          <div className="gallery-filter-bar">
            <button
              className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
            >
              All Photos
            </button>
            <button
              className={`filter-btn ${activeFilter === 'facilities' ? 'active' : ''}`}
              onClick={() => setActiveFilter('facilities')}
            >
              Facilities & Classrooms
            </button>
            <button
              className={`filter-btn ${activeFilter === 'cultural' ? 'active' : ''}`}
              onClick={() => setActiveFilter('cultural')}
            >
              Cultural Events
            </button>
            <button
              className={`filter-btn ${activeFilter === 'sports' ? 'active' : ''}`}
              onClick={() => setActiveFilter('sports')}
            >
              Yoga & Sports
            </button>
          </div>

          {/* Photo Grid */}
          <div className="gallery-grid">
            {filteredImages.map((img) => (
              <div
                key={img.id}
                className="gallery-grid-item"
                onClick={() => openLightbox(img)}
              >
                <div className="gallery-thumb-wrapper">
                  <img src={img.src} alt={img.alt} loading="lazy" />
                  <div className="gallery-thumb-overlay">
                    <span className="zoom-icon">🔍</span>
                    <span className="view-text">{img.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* jQuery Lightbox Modal */}
      <div id="lightbox-overlay" className="lightbox-overlay" style={{ display: 'none' }} onClick={closeLightbox}>
        <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Close modal">&times;</button>
          {selectedImage && (
            <>
              <img src={selectedImage.src} alt={selectedImage.alt} className="lightbox-img" />
              <div className="lightbox-caption">
                <h3>{selectedImage.title}</h3>
                <p>{selectedImage.alt}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
}

export default Gallery;